import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

// import components
import CreateArchiveItem from "../../components/CreateArchive/CreateArchiveItem";
import NavigationBar from "../../components/common/NavigationBar";

// Scss imports
import css from "./CreateArchive.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

interface CreateArchiveProps {
  text?: string;
}

/*const archiveTemplate = [
  {
    numberOfPapers: 4,
    papersFrom: "2021-07-10T12:27:39.015Z",
    papersTo: "2021-07-10T12:32:04.510Z",
    papers: [
      "60e9923b762cb42d206188ac",
      "60e99252762cb42d206188ad",
      "60e99263762cb42d206188ae",
      "60e99344762cb42d206188af"
    ],
    subnumbers: ["16", "17", "18", "19"],
    baseNumber: "611c0d6b9ffad800155cb139"
  },
  {
    numberOfPapers: 1,
    papersFrom: "2021-02-10T17:45:44.358Z",
    papersTo: "2021-02-10T17:45:44.358Z",
    papers: ["60e9dcc878e7693b4c27fe7b"],
    subnumbers: ["1"],
    baseNumber: "611c0db09ffad800155cb13b"
  }
];*/

const CreateArchive: React.FC<CreateArchiveProps> = ({}) => {
  const archiveTemplate = useSelector(
    (state: any) => state.archive.prepareArchiveData
  );

  const [archiveTemplateDoc, setArchiveTemplateDoc] = useState("");

  useEffect(() => {
    setArchiveTemplateDoc(archiveTemplate);
  }, [archiveTemplate]);
  return (
    <div>
      <NavigationBar />
      <div className={css.container}>
        {archiveTemplate && archiveTemplate.length > 0 ? (
          archiveTemplate.map((item, index) => {
            return (
              <CreateArchiveItem
                numberOfPapers={item.numberOfPapers}
                papersFrom={item.papersFrom}
                papersTo={item.papersTo}
                papers={item.papers}
                subnumbers={item.subnumbers}
                baseNumber={item.baseNumber.baseNumber}
                baseNumberId={item.baseNumber._id}
                index={index}
                archiveTemplate={archiveTemplate}
                shelfLifeToData={item.shelfLifeTo}
                key={index}
                type="createArchive"
                id={item._id}
              />
            );
          })
        ) : (
          <div>
            <Link to="/">
              <p>Немате докумената за архивирање, идите на деловодник</p>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateArchive;
